module.exports = __webpack_public_path__ + "img/warning.eace7d4d.svg";